"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createElement;

var _react = _interopRequireDefault(require("react"));

var _camelCase = _interopRequireDefault(require("./camelCase"));

var _constants = require("./constants");

var _ariaRefHelpers2 = _interopRequireDefault(require("./ariaRefHelpers"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function createElement(name) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  function isSeismicComponent(name) {
    return typeof name === 'string' && name.indexOf('-') !== -1;
  }

  function isAttribute(name) {
    return _constants.ATTRIBUTES.indexOf(name) !== -1 || name.startsWith('aria-') || name.startsWith('data-');
  }

  function isMappedToProps(name) {
    return _constants.MAPPED_TO_PROPS.indexOf(name) !== -1;
  }

  var _ariaRefHelpers = (0, _ariaRefHelpers2.default)(name, props),
      handleAriaAccessibility = _ariaRefHelpers.handleAriaAccessibility,
      ariaSetVnode = _ariaRefHelpers.ariaSetVnode,
      requiresRef = _ariaRefHelpers.requiresRef;

  for (var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    children[_key - 2] = arguments[_key];
  }

  if (props && !!Object.keys(props).length && isSeismicComponent(name)) {
    var existingRef = props.ref && typeof props.ref === 'function' && props.ref;
    var attributes = {};
    var properties = {};

    for (var _name in props) {
      if (isAttribute(_name)) attributes[_name] = props[_name];else properties[(0, _camelCase.default)(_name)] = props[_name];
      if (isMappedToProps(_name)) properties[_name] = props[_name];
    }

    if (!!Object.keys(properties).length) {
      var vnode = _react.default.createElement.apply(_react.default, [name, Object.assign({}, attributes, {
        ref: function ref(node) {
          handleAriaAccessibility(node);
          if (!node) return;
          existingRef && existingRef(node);
          Object.assign(node, properties);
        }
      })].concat(children));

      ariaSetVnode(vnode);
      return vnode;
    }
  }

  if (requiresRef) {
    var _vnode = _react.default.createElement.apply(_react.default, [name, _objectSpread({}, props, {
      ref: function ref(node) {
        handleAriaAccessibility(node);

        if (props && props.ref) {
          props.ref(node);
        }
      }
    })].concat(children));

    ariaSetVnode(_vnode);
    return _vnode;
  } else {
    return _react.default.createElement.apply(_react.default, [name, props].concat(children));
  }
}